import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import {
  requestTourneyInfoData,
  requestTourneyEntriesDynamicData,
  requestTourneyTablesDynamicData,
  requestFlightTourneyStackDetails,
  requestFlightTourneyQualifiedPlayers,
  updateShowTourneyRegisterConfirmationPopup,
} from "../../../Poker/redux/slices/lobbySlice";
import useLobby, { usePlayer } from "../data/useLobby";
import useGetAllTourneyTickets from "../data/useGetAllTourneyTickets";

export default function useTourneyDetails() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const getAllTourneyTickets = useGetAllTourneyTickets();
  const player = usePlayer();
  const showTourneyRegisterConfirmationPopup = useSelector(
    (state) => state.lobby?.showTourneyRegisterConfirmationPopup
  );

  // this function to navigate to the tourney details page
  const navigateToTourneyDetails = (tourneyId) => {
  
    try {
      console.log("Navigating to tourney details for ID:", tourneyId);
      if (!tourneyId) {
        console.error("Tourney ID is required to navigate.");
        return;
      }
      dispatch(requestTourneyInfoData({ tourneyId: tourneyId }));
      navigate(`/tourneyDetails/${tourneyId}`);
    } catch (error) {
      console.log("errorerrorerror", error);
    }
  };
  // TODO: when data part will be ready, we have to modifiy
  // this function to fetch tourney entries and tables
  const fetchTourneyEntries = (
    tourneyId,
    pageNumber = 0,
    pageSize = 50,
    searchPlayerName = ""
  ) => {
    try {
      if (!tourneyId) {
        console.error("Tourney ID is required to fetch entries.");
        return;
      }
      dispatch(
        requestTourneyEntriesDynamicData({
          tourneyId,
          pageNumber,
          pageSize,
          searchPlayerName,
        })
      );
    } catch (error) {
      console.error("Error fetching tourney entries:", error);
    }
  };

  // TODO: when data part will be ready, we have to modifiy
  // this function to fetch tourney tables
  const fetchTourneyTables = (tourneyId) => {
    try {
      if (!tourneyId) {
        console.error("Tourney ID is required to fetch tables.");
        return;
      }
      dispatch(requestTourneyTablesDynamicData({ tourneyId }));
    } catch (error) {
      console.error("Error fetching tourney tables:", error);
    }
  };

  /**
   * Fetches the target tourney tables for a given tournament.
   * @param {string} tourneyId - The tournament ID.
   */
  const fetchTargetTourneyTables = (tourneyId) => {
    try {
      if (!tourneyId) {
        console.error("Tourney ID is required to fetch target tourney tables.");
        return;
      }
      // Dispatch an action or make an API call to fetch target tourney tables here.
      dispatch(requestTourneyTablesDynamicData({ tourneyId }));
      console.log("Fetching target tourney tables for tourneyId:", tourneyId);
    } catch (error) {
      console.error("Error fetching target tourney tables:", error);
    }
  };

  const fetchFlightTourneyStackDetails = (tourneyId) => {
    try {
      if (!tourneyId) {
        console.error(
          "Tourney ID is required to fetch flight tourney stack details."
        );
        return;
      }
      let payload = {
        playerName: player?.userName,
        tourneyId: tourneyId,
      };
      // Dispatch an action or make an API call to fetch flight tourney stack details here.
      dispatch(requestFlightTourneyStackDetails(payload));
      console.log(
        "Fetching flight tourney stack details for tourneyId:",
        tourneyId
      );
    } catch (error) {
      console.error("Error fetching flight tourney stack details:", error);
    }
  };

  const fetchFlightTourneyQualifiedPlayers = (tourneyId) => {
    if (!tourneyId) {
      console.error(
        "Tourney ID is required to fetch flight tourney qualified players."
      );
      return;
    }
    let payload = {
      playerName: player?.userName,
      tourneyId: tourneyId,
    };

    dispatch(requestFlightTourneyQualifiedPlayers(payload));
  };

  // popup handle
  const openRegPopup = (isOpen) => {
    dispatch(updateShowTourneyRegisterConfirmationPopup({ isOpen }));
  };

  //check user has ticket
  const checkUserHasTicket = (tourneyId) => {
    let ticketTourneyIds = getAllTourneyTickets.map((eachTicket) => {
      return eachTicket.tourneyId;
    });
    return ticketTourneyIds.includes(tourneyId);
  };
  // get tourney buy-in amount
  const getTourneyBuyIn = (singleTourneyId) => {
    if (singleTourneyId?.bountyTourney) {
      return (
        singleTourneyId?.buyIn +
        singleTourneyId?.tourneyRake +
        singleTourneyId?.bountyBuyIn
      );
    } else {
      return singleTourneyId?.buyIn + singleTourneyId?.tourneyRake;
    }
  };

  return {
    navigateToTourneyDetails,
    fetchTourneyEntries,
    fetchTourneyTables,
    fetchTargetTourneyTables,
    fetchFlightTourneyStackDetails,
    fetchFlightTourneyQualifiedPlayers,
    openRegPopup,
    showTourneyRegisterConfirmationPopup,
    checkUserHasTicket,
    getTourneyBuyIn,
  };
}
